import { Box } from "@mui/material";
import SoftButton from "../../components/buttons/SoftButton";
import { ReactComponent as FlashIcon } from "../../icons/icon_files/flash.svg";

export default function SoftButtonDemo() {
  return (
    <Box>
      <Box display="flex" gap={3} flexDirection="column">
        {[null, "icon", "disabled", "loading"].map((type) => (
          <Box display="flex" gap={3} alignItems="center">
            {["xs", "small", "medium", "large"].map((size) => (
              <SoftButton
                key={size}
                onClick={() => {}}
                size={size}
                color="primary"
                icon={type === "icon" ? FlashIcon : null}
                disabled={type === "disabled" ? true : false}
                loading={type === "loading" ? true : false}
              >
                Soft Button
              </SoftButton>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
